angular.module('app.ctrls').directive('runOnEnter', [
    function () {
        return {
            restrict: 'A',
            scope: {
                runOnEnter: '&'
            },
            link: function (scope, elem, attrs) {
                // Detect enter keypress
                $(elem).on('keydown', function (e) {
                    if (e.which == 13) {
                        e.preventDefault();
                        scope.runOnEnter();
                    }
                });
            }
        };
    }
]);
